/**
 * Design tokens — import da project/design/tokens.json.
 * Duplicati qui per DX (tipizzati). Fonte di verita': `project/design/tokens.json`.
 */
export const brand = {
  primary: '#e5252b',       // rosso Lanciano FC (design)
  primaryDeep: '#a3161b',   // derivato dal rosso del design (piu' scuro), non e' un colore del design
  secondary: '#000000',     // nero Lanciano FC (design)
  accent: '#fad849',        // giallo Lanciano FC (design)
  ink: '#000000',
  inkSoft: '#1A1A1F',
  bg: '#f2f0eb',
  bgAlt: '#F0EEE9',
  paper: '#FFFFFF',
  paper2: '#fafaf7',
  line: '#E4E1D8',
  textPrimary: '#0B0B0D',
  textSecondary: '#7A756C',
  gold: '#C99A2A',
  goldBg: '#FFF5E8',
  commerce: '#1a6fd4',
  commerceBg: '#EAF4FF',
  win: '#0A8F3F',
  draw: '#C99A2A',
  loss: '#e5252b',
  danger: '#d42027',
  warn: '#e8911a',
  muted: '#7a756c',
  muted2: '#a8a39a',
} as const;

export const typography = {
  display: "'Galano Grotesque', system-ui, sans-serif",
  body: "'Galano Grotesque', system-ui, sans-serif",
  galano: "'Galano Grotesque', 'Helvetica Neue', system-ui, sans-serif",
  backoffice: "'Galano Grotesque', 'Helvetica Neue', system-ui, sans-serif",
  fallback: "'Inter', system-ui, sans-serif",
} as const;

export const radius = {
  card: 14,
  cardLarge: 16,
  pill: 999,
  small: 4,
  tiny: 3,
} as const;
